
import { Component, Vue, Prop } from "vue-property-decorator"
import { LabeledValueWithFieldInfo } from "@/types/user"
import { formatFieldsMixin } from "@/mixins/formatFieldsMixin"

@Component({
	components: {}
})
export default class UserHeaderFields extends Vue {
	@Prop({ default: () => { return {} } })
	userHeaderFieldValues!: { [key: string]: LabeledValueWithFieldInfo }

	public getLabeledValueDisplayLabel (labeledValue: LabeledValueWithFieldInfo): string {
		const label = formatFieldsMixin.methods.getDisplayLabelFromLabeledValueWithFieldInfo(labeledValue)
		return label
	}

	public sanitizeFieldTitle (title: string) : string {
		const result = title.replace(/[^a-zA-Z0-9]/g, "")
		return result
	}
}

